import { createFileRoute } from '@tanstack/react-router';
import { Stack } from '@mantine/core';
import { PackConversionFlow } from '../../../features/production-packconv/components/PackConversionFlow';
import { PackConversionsRegister } from '../../../features/production-packconv/components/PackConversionsRegister';

/** Pack conversion (BUILD_SPEC.md §8.5) — guided flow + register on one page,
 * mirroring the silo status overview's "flow + recent register" combination
 * (features/silo-counts/routes/silo-counts/index.tsx). */
export const Route = createFileRoute('/_authenticated/production-packconv/pack-conversion')({
  component: PackConversionPage,
});

function PackConversionPage() {
  return (
    <Stack gap="xl">
      <PackConversionFlow />
      <PackConversionsRegister />
    </Stack>
  );
}
